import { render, staticRenderFns } from "./taoCanBoTrucThuocModal.vue?vue&type=template&id=8e0d6846&"
import script from "./taoCanBoTrucThuocModal.vue?vue&type=script&lang=js&"
export * from "./taoCanBoTrucThuocModal.vue?vue&type=script&lang=js&"
import style0 from "./taoCanBoTrucThuocModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports